import React from "react";
import "./HeroSection.css";

function HeroSection() {
  return (
    <div className="hero-section">
      <video className="hero-video" autoPlay loop muted playsInline>
        <source src="/hero.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <h1 className="hero-title">RAGHAV KHANNA</h1>
        <p className="hero-subtitle">PHOTOGRAPHER-DIRECTOR</p>
      </div>
    </div>
  );
}

export default HeroSection;
